(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["heid-document-cards"] && !Shopify.designMode) return;
  try {
    
  // Heid Music mod: native dialog provides keyboard focus trapping and Escape support.
  if (!customElements.get('heid-document-lightbox')) {
    customElements.define('heid-document-lightbox', class extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        this.initialized = true;
        this.dialog = this.querySelector('dialog');
        this.trigger = this.querySelector('.heid-document-lightbox__trigger');
        if (!this.dialog || !this.trigger) return;
        this.trigger.addEventListener('click', (event) => {
          if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey || !this.dialog.showModal) return;
          event.preventDefault();
          if (this.dialog.open) return;
          this.previousOverflow = document.documentElement.style.overflow;
          this.dialog.showModal();
          document.documentElement.style.overflow = 'hidden';
          this.locked = true;
        });
        this.querySelector('.heid-document-lightbox__close').addEventListener('click', () => this.dialog.close());
        this.dialog.addEventListener('click', (event) => {
          if (event.target !== this.dialog) return;
          const rect = this.dialog.getBoundingClientRect();
          if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) this.dialog.close();
        });
        this.dialog.addEventListener('close', () => {
          this.unlock();
          if (this.trigger.isConnected) this.trigger.focus({ preventScroll: true });
        });
      }
      unlock() {
        if (!this.locked) return;
        document.documentElement.style.overflow = this.previousOverflow;
        this.locked = false;
      }
      disconnectedCallback() {
        if (this.dialog && this.dialog.open) this.dialog.close();
        this.unlock();
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
